// The custom-tab state contract for the `history:review` panelKind — the opaque
// blob persisted in the tab and revived on reload. Pure (no React), so it lives
// out of the renderer view file: the panelKind descriptor (idFor/title/revive),
// the renderer, and the tests all parse through this one validator.
import type { JsonValue } from "@archlang/app-shell/workbench";

export interface ReviewState {
  readonly slug: string;
  readonly repo: string;
  readonly changesetId: string;
  readonly number: number;
  readonly title?: string;
}

/** Parse the opaque tab state; returns null when malformed (tab dropped on
 *  reload). Rejects a non-finite `number` (NaN/Infinity survive `typeof` but
 *  would leave the changeset query permanently disabled). */
export function parseReviewState(raw: JsonValue): ReviewState | null {
  if (typeof raw !== "object" || raw === null || Array.isArray(raw)) return null;
  const r = raw as Record<string, JsonValue>;
  if (typeof r.slug !== "string" || typeof r.repo !== "string") return null;
  if (typeof r.changesetId !== "string") return null;
  if (typeof r.number !== "number" || !Number.isFinite(r.number)) return null;
  return {
    slug: r.slug,
    repo: r.repo,
    changesetId: r.changesetId,
    number: r.number,
    title: typeof r.title === "string" ? r.title : undefined,
  };
}
